import { render } from "./ProducerLateDeliveries.vue?vue&type=template&id=768fa63d"
import script from "./ProducerLateDeliveries.vue?vue&type=script&lang=js"
export * from "./ProducerLateDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__